<template>
  <div class="loading">
    <h1>Error ({{ fetchingErrorCode }})</h1>
    <p>{{ fetchingError }}</p>
    <a
      class="btn button et_pb_button margin-top-23"
      @click="restart"
    >Zurück</a>
  </div>
</template>
<script>
import { mapState } from "vuex";
import router from '../router'

export default {
    name: 'ErrorScreen',
    computed: 
        mapState('orders', ['fetchingErrorCode', 'fetchingError']),
    methods: {
        restart() {
            router.push({name: 'BasicForm'});
            location.reload();
        }
    }
}
</script>
<style lang="scss" scoped>
.loading {
position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ab6363f2;
    color: #fff;
    font-size: 32px;
    text-align: center;
    z-index: 100;
    padding: 20px;
    min-height: 80vh;

    h1 {
        color: #fff !important;
    }

    p {
        font-size: 20px;
        line-height: 1.4;
    }
}
</style>